import { List, useTable } from '@refinedev/antd';
import { Tag } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AppTable from '@/components/general/AppTable';
import { useUserContext } from '@/contexts/UserContext';
import { useListStatePersistence } from '@/hooks/useListStatePersistence';
import { PRODUCT_TYPES, ProductTypeStrings } from '@/model/Logistic/PackageItem/ProductTypes';
import { Product } from '@/model/Product/Product';
import { RESOURCES } from '@/Resources';

import ProductCatalogFilter from './ProductCatalogFilter/ProductCatalogFilter';

const ProductCatalogList = () => {
  const { t } = useTranslation();
  const [isReady, setIsReady] = useState(false);
  const { pageSizePreference } = useUserContext();
  const {
    tableProps,
    filters,
    setFilters,
    setCurrentPage,
    sorters,
    setSorters,
    currentPage,
    pageSize,
    setPageSize,
  } = useTable<Product>({
    resource: 'elements',
    syncWithLocation: true,
    queryOptions: {
      refetchInterval: 300000, // 5 minutes
      retry: 3,
      enabled: isReady,
    },
    pagination: {
      pageSize: pageSizePreference,
    },
  });

  useListStatePersistence({
    resource: RESOURCES.PRODUCT_CATALOG,
    filters,
    setFilters,
    sorters,
    setSorters,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    // Garantiza que el filtro de tipo siempre esté presente al restaurar estado.
    defaultFilters: [{ field: 'type', operator: 'eq', value: PRODUCT_TYPES.PRODUCT }],
    onReady: () => setIsReady(true),
  });

  return (
    <List
      headerButtons={() => (
        <>
          <Tag color="blue">{`${t('Tipo')}: ${ProductTypeStrings[filters.find(f => (f as any)?.field === 'type')?.value]}`}</Tag>
          <ProductCatalogFilter
            filters={filters}
            setFilters={setFilters}
            setCurrent={setCurrentPage}
          />
        </>
      )}>
      <AppTable<Product> {...tableProps} rowKey="id" scroll={{ x: 800, y: 'calc(100dvh - 310px)' }}>
        <AppTable.Column width={500} dataIndex="name" title={t('Nombre')} />
        <AppTable.Column
          width={140}
          dataIndex="price"
          title={t('Precio')}
          render={(v, record) => (v ? `${record.symbol ? record.symbol + ' ' : ''}${v}` : 'N/A')}
        />
        <AppTable.Column
          width={140}
          dataIndex="price_with_taxes"
          title={t('Precio con impuestos')}
          render={(v, record) => (v ? `${record.symbol ? record.symbol + ' ' : ''}${v}` : 'N/A')}
        />

        <AppTable.Column width={300} dataIndex="category_name" title={t('Categoría')} />
      </AppTable>
    </List>
  );
};

export default ProductCatalogList;
